/**
 * 微信支付订单确认页（确认后跳转到班优的支付页面）
 */

import React, { useEffect } from "react";
import { getQuery } from "@/utils/navigator";
import { createWxClientAuthUrl } from "@/services/api_user";
import { isSupportWxLogin } from "@/utils/platform";
import PayContainer from "./PayContainer";
import FailPng from "../../images/fail.png";
import { title } from "../const";
import "./index.less";
import VConsole from 'vconsole';

if (['dev', 'test','uat'].includes(import.meta.env.MODE)) {
  new VConsole();
}

export interface PayPageProps {}

export interface PayBeginState {
  ifOutDate: boolean;
}

const PayPage: React.FC<PayPageProps> = () => {
  const code = getQuery("code");

  useEffect(() => {
    document.title = title;
  }, []);

  // 判断是否支持微信登录
  if (!isSupportWxLogin()) {
    return (
      <div className="no-support-wx">
        <div className="desc-container">
          <img className="fail-img" src={FailPng} alt="支付失败" />
          <p className="fail-text">请使用微信扫码</p>
          <p className="notice-text">暂不支持其他方式</p>
        </div>
      </div>
    );
  }

  // 先获取wxCode
  if (!code) {
    const url = createWxClientAuthUrl(location.href, { appid: import.meta.env.VITE_WX_PAYMENT_APP_ID, scope: 'snsapi_base' });
    window.location.replace(url);
    return null;
  }

  return <PayContainer />;
};

export default PayPage;
